export default (state = 0, { type, payload }) => {
  if (type === 'GREENMILE_ROUTEMONITOR_PENDING_ORDERS_AGGREGATE_SUCCESS') {
    return payload;
  }
  return state;
};
